import { createTheme, Theme } from '@mui/material/styles';

export const buildTheme = (mode: 'light' | 'dark'): Theme => createTheme({
  palette: {
    mode,
    grey: {
      50: '#fafafa',
      100: '#f5f5f5',
      200: '#eeeeee',
      300: '#e0e0e0',
      400: '#bdbdbd',
      500: '#9e9e9e',
      600: '#757575',
      700: '#616161',
      800: '#424242',
      900: '#212121',
    },
    primary: {
      // Zbliżony do brandu z widoku projektów (fiolet)
      main: '#4040DB',
      light: '#6D6DF0',
      dark: '#2E2EB6',
      contrastText: '#fff',
    },
    secondary: {
      main: '#9c27b0',
      light: '#ba68c8',
      dark: '#7b1fa2',
      contrastText: '#fff',
    },
    background: mode === 'light' ? {
      default: '#FAFAFA',
      paper: '#ffffff',
    } : {
      default: '#121212',
      paper: '#1c1c1c',
    },
    text: mode === 'light' ? {
      primary: '#333333',
      secondary: '#666666',
    } : {
      primary: '#e6e6e6',
      secondary: '#a1a1a1',
    },
  },
  typography: {
    fontFamily: 'Inter, Roboto, Helvetica, Arial, sans-serif',
    h5: { fontWeight: 700 },
    h6: { fontWeight: 700 },
    button: { fontWeight: 600, textTransform: 'none' },
  },
  shape: { borderRadius: 4 },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        // Rozjaśnij ikonę kalendarza w inputach typu date w trybie ciemnym
        ...(mode === 'dark'
          ? {
              'input[type="date"]::-webkit-calendar-picker-indicator': {
                filter: 'invert(1) brightness(1.2)'
              },
              'input[type="datetime-local"]::-webkit-calendar-picker-indicator': {
                filter: 'invert(1) brightness(1.2)'
              }
            }
          : {}),
        // Wygładzanie czcionek i tło aplikacji
        'html, body, #root': { height: '100%' },
        body: {
          WebkitFontSmoothing: 'antialiased',
          MozOsxFontSmoothing: 'grayscale',
        },
      }
    },
    MuiCard: { styleOverrides: { root: { boxShadow: mode === 'light' ? '0 6px 20px rgba(64,64,219,0.08)' : '0 6px 20px rgba(0,0,0,0.5)', backgroundColor: mode==='light' ? undefined : '#1e1e1e', borderRadius: 4 } } },
    MuiPaper: { styleOverrides: { root: { backgroundImage: 'none', borderRadius: 4 } } },
    MuiTableCell: { styleOverrides: { root: { borderBottomColor: mode==='light' ? '#e8e8ef' : '#2a2a2a' } } },
    MuiInputBase: { styleOverrides: { root: { backgroundColor: mode==='light' ? undefined : 'transparent', borderRadius: 4 } } },
    MuiAppBar: { styleOverrides: { colorDefault: { backgroundColor: mode==='light' ? '#ffffff' : '#1e1e1e' } } },
    MuiButton: { styleOverrides: { root: { borderRadius: 4 }, containedPrimary: { boxShadow: 'none' } } },
  },
});

export const defaultTheme = buildTheme('light');
export default defaultTheme;
